import { useState, useEffect } from "react";
import logo from "../../assets/logo.svg";
import "./header.scss";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../helper/swithclang";
import { Link, useParams, useNavigate } from "react-router-dom";

const Header = () => {
  const [isMenuClicked, setIsmenuclicked] = useState(false);
  const { t } = useTranslation();
  const { lang = "ka" } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.toggle("no-scroll", isMenuClicked);
    return () => document.body.classList.remove("no-scroll");
  }, [isMenuClicked]);

  const handleBurgerMenu = (e) => {
    setIsmenuclicked(!isMenuClicked);
    e.stopPropagation();
  };

  return (
    <header className="header">
      <div className="company-hd-logo">
        <Link to={`/${lang}`}>
          <img src={logo} alt="Prime Clean - დასუფთავების სერვისი" />
        </Link>
      </div>
      <nav className="navigation" aria-label="Main navigation">
        <ul className="ul-lists">
          <li>
            <Link to={`/${lang}`}>{t("header1")}</Link>
          </li>
          <li>
            <Link to={`/${lang}`}>{t("header2")}</Link>
          </li>
          <li>
            <Link to={`/${lang}/contact`}>{t("header3")}</Link>
          </li>
        </ul>
      </nav>
      <LanguageSwitcher />
      <div className="burger-menu" onClick={handleBurgerMenu} aria-label="Menu">
        <div className="lines-container">
          <div className="top-line line"></div>
          <div className="middle-line line"></div>
          <div className="bottom-line line"></div>
        </div>
      </div>
      {isMenuClicked && (
        <div className="burger-items-container">
          <ul className="burger-items">
            <li>
              <Link to={`/${lang}`}>{t("header1")}</Link>
            </li>
            <li>
              <Link to={`/${lang}`}>{t("header2")}</Link>
            </li>
            <li>
              <Link to={`/${lang}/contact`}>{t("header3")}</Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
